import { isPlatformBrowser } from "@angular/common";
import { Inject, Injectable, PLATFORM_ID } from "@angular/core";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function getWindow(): any {
  return window;
}

@Injectable({
  providedIn: "root"
})
export class WindowService {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  constructor(@Inject(PLATFORM_ID) private platformId: any) {}

  // TODO(v5): Correct this to be `Window | null`
  get nativeWindow(): Window {
    if (!isPlatformBrowser(this.platformId)) {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      return null as any;
    }

    return getWindow();
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  createDataLayer(layerId: string, data: any = null): void | null {
    if (!isPlatformBrowser(this.platformId)) {
      return null;
    }

    const window: Window | null = this.nativeWindow;
    if (window) {
      const existing: unknown[] = (window as unknown as Record<string, unknown>)[layerId]
        ? ((window as unknown as Record<string, unknown>)[layerId] as unknown[])
        : [];

      if (!existing.length && data !== null) {
        existing.push(data);
      }

      (window as unknown as Record<string, unknown>)[layerId] = existing;
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  pushData(layerId: string, data: any): void | null {
    if (!isPlatformBrowser(this.platformId)) {
      return null;
    }

    if (this.nativeWindow) ((this.nativeWindow as unknown as Record<string, unknown>)[layerId] as unknown[]).push(data);
  }
}
